import _objectSpread from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp } from "@/mixins/index";
export default {
  mixins: [popUp],
  data: function data() {
    return {
      dialogFormVisible: false,
      optionsoRganization: [],
      formData: {
        id: "",
        email: "",
        password: "",
        nickname: "",
        auth_group_id: "",
        status: 1
      },
      rules: {
        email: [{
          required: true,
          message: "请输入账号",
          trigger: "blur"
        }],
        nickname: [{
          required: true,
          message: "请输入昵称",
          trigger: "blur"
        }],
        auth_group_id: [{
          required: true,
          message: "请选择角色",
          trigger: "blur"
        }],
        status: [{
          required: true,
          message: "请选择用户状态",
          trigger: "blur"
        }]
      }
    };
  },
  computed: {},
  created: function created() {},
  methods: {
    init: function init(id) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var roleList;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$api.userAddList({
                  id: 't'
                });

              case 2:
                roleList = _context.sent;
                _this.optionsoRganization = roleList.data;

                _this.copyPrimitive();

                if (!id) {
                  _context.next = 8;
                  break;
                }

                _context.next = 8;
                return _this.$api.userDetails({
                  id: id
                }).then(function (res) {
                  if (res.status == 200) {
                    _this.formData = _objectSpread({}, res.data.admin_info);
                  }
                });

              case 8:
                _this.copyData();

                _this.dialogFormVisible = true;

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$refs.ruleForm.validate(function (valid) {
                  if (valid) {
                    var reqFn = _this2.formData.id == '' ? 'userAdd' : 'userUpd';

                    _this2.$api[reqFn](_this2.formData).then(function (res) {
                      if (res.status == 200) {
                        _this2.$message.success(_this2.formData.id == '' ? '添加成功' : '修改成功');

                        _this2.$emit('change');

                        _this2.dialogFormVisible = false;
                      }
                    });
                  }
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};